<button
    type="button"
    class="menu"
    (click)="showSidebar()"
    [class.closed]="isClosed"
    [attr.aria-expanded]="!isClosed"
    [attr.aria-label]="isClosed ? 'Open sidebar' : 'Close sidebar'"
    aria-live="polite">
    @if (isClosed) {
    <i class="fa fa-bars menu__icon"></i>
    } @else {
    <i class="fa fa-close menu__icon"></i>
    }
</button>
